























import {Component, Vue} from "vue-property-decorator";
import {namespace} from 'vuex-class';
const sidebarDialog = namespace('dialog')
@Component
export default class SidebarDialog extends Vue {
  @sidebarDialog.Getter('GetSidebarDialogShow') protected GetSidebarDialogShow:any
  @sidebarDialog.Getter('GetFormSidebarDialog') protected GetFormSidebarDialog:any
  @sidebarDialog.Mutation('SetSidebarDialogShow') protected show:any
}
